import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { Layout } from "@/components/Layout";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      toast.success("Free account created. Pick a plan to activate your membership.");
      navigate("/pricing");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout hideFooter>
      <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4 py-12 bg-grid bg-grid-fade">
        <div className="w-full max-w-lg surface p-8" data-testid="register-card">
          <div className="section-label mb-2">— CREATE ACCOUNT</div>
          <h1 className="font-chivo font-black text-3xl text-white uppercase tracking-tight mb-2">Join Dry Ice Connect</h1>
          <p className="font-plex text-sm text-[#9CA3AF] mb-6">Free to create. Choose Level 1 or Level 2 after signup to unlock member features.</p>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="register-form">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="font-mono text-xs text-[#9CA3AF] tracking-widest uppercase block mb-2">Full Name</label>
                <input value={form.name} onChange={onChange("name")} required className="input-rugged" data-testid="register-name-input" />
              </div>
              <div>
                <label className="font-mono text-xs text-[#9CA3AF] tracking-widest uppercase block mb-2">Company</label>
                <input value={form.company} onChange={onChange("company")} className="input-rugged" data-testid="register-company-input" />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="font-mono text-xs text-[#9CA3AF] tracking-widest uppercase block mb-2">Email</label>
                <input type="email" value={form.email} onChange={onChange("email")} required className="input-rugged" data-testid="register-email-input" />
              </div>
              <div>
                <label className="font-mono text-xs text-[#9CA3AF] tracking-widest uppercase block mb-2">Phone</label>
                <input value={form.phone} onChange={onChange("phone")} className="input-rugged" data-testid="register-phone-input" />
              </div>
            </div>
            <div>
              <label className="font-mono text-xs text-[#9CA3AF] tracking-widest uppercase block mb-2">Password</label>
              <input type="password" value={form.password} onChange={onChange("password")} required minLength={8} className="input-rugged" data-testid="register-password-input" />
              <div className="font-mono text-xs text-[#52525B] mt-1">Minimum 8 characters.</div>
            </div>
            {error && <div className="text-sm font-mono text-[#EF4444]" data-testid="register-error">{error}</div>}
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="register-submit-button">
              {loading ? "Creating account..." : "Create Account"}
            </button>
          </form>
          <div className="mt-6 font-mono text-xs text-[#9CA3AF] text-center">
            Already a member? <Link to="/login" className="text-[#00D4FF] hover:underline">Login</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
